module.exports = __webpack_public_path__ + "img/desconexionElectrica.df911c3e.svg";